<template>
    <div class="page bg-white">
        <div>
            <van-cell title="店员" is-link :value="clerkName" @click="show = true" />
        </div>
        <div class="cellBox flexStyle">
            <div class="title">订单类型</div>
            <van-radio-group v-model="orderType" direction="horizontal">
                <van-radio name="1" @click="orderTypeClick">首单</van-radio>
                <van-radio name="2" @click="orderTypeClick">续单</van-radio>
                <van-radio name="3" @click="orderTypeClick">打赏</van-radio>
            </van-radio-group>
        </div>
        <div class="cellBox">
            <div class="flexStyle" v-for="(group,groupIndex) in itemGroupList" :key="groupIndex">
                <div class="title">{{group.label}}</div>
                <span v-for="(item, itemIndex) in group.list" :key="itemIndex" v-if="!disabledItemIds.includes(item.id)" class="notSelected" :class="{ 'selected': group.selected == itemIndex }" @click="serviceClick(groupIndex, itemIndex, item)">
                    <div>{{item.name}}</div>
                </span>
            </div>
        </div>
        <div class="cellBox">
            <van-cell-group>
                <van-field v-model="price" type="number" label="价格" placeholder="请输入价格" />
            </van-cell-group>
        </div>
        <div class="cellBox">
            <van-cell-group>
                <van-field v-model="weiXin" label="微信号" placeholder="请输入微信号（选填）" />
            </van-cell-group>
        </div>
        <div class="cellBox">
            <van-cell-group>
                <van-field v-model="orderNotes" rows="2" maxlength="100" autosize label="订单备注" type="textarea" placeholder="请输入备注（选填）" />
            </van-cell-group>
        </div>
        <div>
            <van-button round type="primary" style="width: 100%" @click="submitClick">提交</van-button>
        </div>


        <van-popup v-model="show" position="bottom">
            <van-search v-model="search" placeholder="请输入搜索店员" />
            <div class="clerkBox" v-for="(item,index) in list" :key="index" @click="clerkClick(item.id,item.name)">{{item.name}}</div>
        </van-popup>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {
        Cell,
        CellGroup,
        Popup,
        Search,
        Checkbox,
        CheckboxGroup,
        RadioGroup,
        Radio,
        Field,
        Button,
        Dialog,
        Toast
    } from 'vant';
    import {getClerkList, getItemList, submitOrder} from '@/api/kf/order'
    import Decimal from "decimal.js";

    Vue.use(Cell)
        .use(CellGroup)
        .use(Popup)
        .use(Search)
        .use(Checkbox)
        .use(CheckboxGroup)
        .use(RadioGroup)
        .use(Radio)
        .use(Field)
        .use(Button)
        .use(Toast)

    export default {
        name: 'order-entry',
        data () {
            return {
                list: [],
                itemGroupList: [],
                itemId: '',
                disabledItemIds: [],
                itemMap: {},
                itemPriceMap: {},
                show: false,
                search: '',
                price: '',
                weiXin: '',
                orderType: '',
                orderNotes: '',
                clerkName: '',
                clerkId: ''
            }
        },
        methods: {
            clerkList(){
                getClerkList(
                    this.search
                ).then(res => {
                    const data = res.data
                    if (data.code == 0) {
                        this.list = data.list
                    } else {
                        Dialog.alert({
                            title: '加载失败',
                            message: data.msg
                        })
                    }
                })
            },
            clerkClick(id,name){
                this.orderType = ''
                this.itemGroupList = []
                this.price = ''
                this.clerkName = name
                this.clerkId = id
                this.show = false
            },
            serviceClick(groupIndex, itemIndex, item){
                if (this.disabledItemIds.indexOf(item.id) != -1) {
                    return
                }
                this.$set(this.itemGroupList[groupIndex], 'selected', itemIndex)
                if (this.itemGroupList.length - 1 > groupIndex) {
                    this.itemGroupList.splice(groupIndex + 1, this.itemGroupList.length - 1 - groupIndex)
                }
                const list = this.itemMap[item.id]
                if (list != null && list.length > 0) {
                    this.itemGroupList.push({
                        label: item.childrenLabel,
                        list: list
                    })
                    this.price = ''
                } else {
                    const itemGroup = this.itemGroupList[this.itemGroupList.length - 1]
                    const selectedItem = itemGroup.list[itemGroup.selected]
                    const itemId = selectedItem.id
                    this.price = this.formatPrice(this.itemPriceMap[1][itemId])
                }
            },
            orderTypeClick(){
                this.price = ''
                this.itemGroupList = []
                this.itemId = ''
                if ((this.orderType == 1 || this.orderType == 2) && this.clerkName != ''){
                    getItemList(this.clerkId).then(res => {
                        const data = res.data
                        if (data.code == 0) {
                            this.itemMap = data.itemMap
                            this.itemPriceMap = data.itemPriceMap
                            if (this.itemMap[0] != null){
                                this.itemGroupList.push({
                                    label: '服务类型',
                                    list: this.itemMap[0]
                                })
                            }
                            this.disabledItemIds = data.disabledItemIds
                        } else {
                            Dialog.alert({
                                title: '加载失败',
                                message: data.msg
                            })
                        }
                    })
                }
            },
            formatPrice(price) {
                if (price != null) {
                    return Decimal.div(price, 100).toString()
                }
                return ''
            },
            decimal(num){
                let result = (num.toString()).indexOf(".");
                if(result != -1) {
                    return true
                } else {
                    return false
                }
            },
            submitClick(){
                if (this.clerkName == ''){
                    Toast('请选择' + this.$store.state.label.clerkLabel)
                    return
                }
                if(this.orderType == ''){
                    Toast('请选择订单类型')
                    return
                }
                let type = ''
                let isContinued = true
                if (this.orderType == 1 || this.orderType == 2){
                    type = 'assigned'
                }else if (this.orderType == 3){
                    type = 'reward'
                }
                if (this.orderType == 1){
                    isContinued = false
                }
                if (this.orderType != 3){
                    const itemGroup = this.itemGroupList[this.itemGroupList.length - 1]
                    const selectedItem = itemGroup.list[itemGroup.selected]
                    if (selectedItem == null) {
                        Toast('请选择'+ itemGroup.label)
                        return
                    }
                    this.itemId = selectedItem.id
                    if (this.itemId == null) {
                        Toast('请选择'+ itemGroup.label)
                        return
                    }
                }
                if (this.price == ''){
                    Toast('请输入价格')
                    return
                }else if (this.price <= 0){
                    Toast('请输入正确的价格')
                    return
                }else if (this.decimal(this.price)){
                    if (this.price.toString().split('.')[1].length > 2){
                        Toast('请输入正确的价格')
                        return
                    }
                }
                Toast.loading({
                    mask: true,
                    message: '加载中...'
                })
                submitOrder(
                    type,
                    this.clerkId,
                    this.itemId,
                    isContinued,
                    Decimal.mul(this.price, 100).toNumber(),
                    this.weiXin,
                    this.orderNotes
                ).then(res => {
                    Toast.clear()
                    const data = res.data
                    if (data.code == 0) {
                        Dialog.alert({
                            title: '提示',
                            message: '提交成功'
                        }).then(() => {
                            // this.$router.back()
                          //整个刷新
                          // this.$router.go(0)
                              this.reset()
                        })
                    } else {
                        Dialog.alert({
                            title: '提交失败',
                            message: data.msg
                        })
                    }
                })
            },
          reset(){
            this.clerkId = ''
            this.itemId = ''
            this.price = ''
            this.weiXin = ''
            this.orderNotes = ''
            this.orderType = ''
            this.orderType = ''
            this.itemGroupList = []
            this.price = ''
            this.clerkName = ''
            this.clerkId = ''
            this.show = false
          }
        },
        watch: {
            search: function () {
                this.clerkList()
            }
        },
        mounted() {
            this.clerkList()
        },
        updated() {
          // 统一替换标签
          this.$replaceLabel(document.body, this.$store.state.label, true)
        }
    }
</script>

<style lang="less" scoped>
.page{
    padding: 15px;
}
.cellBox{
    margin: 10px 0;
}
.flexStyle{
    display: flex;
    padding: 10px 16px;
}
.title{
    -webkit-box-flex: 0;
    width: 6.2em;
    color: #646566;
    flex: none;
    margin-right: 12px;
    box-sizing: border-box;
    word-wrap: break-word;
}
.notSelected{
    margin: 0 5px 5px 0;
    padding: 5px;
    border-radius: 5px;
    background: #f5f5f5;
}
.selected{
    margin: 0 5px 5px 0;
    padding: 5px;
    border-radius: 5px;
    background: #07c160;
    color: #fff;
}
.clerkBox{
    border-bottom: 1px #f5f5f5 solid;
    padding: 15px;
}
/deep/.van-hairline--top-bottom:after{
    border: none;
}
/deep/.van-field__control{
    background: #f5f5f5;
    padding: 5px;
    border-radius: 5px;
}
/deep/.van-radio{
    margin-bottom: 5px;
}
</style>
